import { useTranslation } from "react-i18next";import React, { createContext, useContext, useState, useEffect } from 'react';
import { authAPI, isAuthenticated, getCurrentUser, logout as apiLogout, setAuthToken, getAuthToken } from '@/shared/services/api';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {const { t } = useTranslation("common");
  const [user, setUser] = useState(getCurrentUser());
  const [token, setToken] = useState(getAuthToken());
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if token is valid on mount
    const checkAuth = async () => {
      console.log('[AuthContext] Checking auth on mount...');
      if (isAuthenticated()) {
        try {
          console.log('[AuthContext] Token found, fetching user profile...');
          const userData = await authAPI.getMe();
          console.log('[AuthContext] User profile fetched:', userData.email);
          setUser(userData);
          setToken(getAuthToken());
          setAuthToken(getAuthToken(), userData);
        } catch (error) {
          console.error('[AuthContext] Failed to validate session:', error);
          // Token invalid, clear it
          setAuthToken(null, null);
          setUser(null);
          setToken(null);
        }
      } else {
        console.log('[AuthContext] No token found on mount');
      }
      setLoading(false);
    };

    checkAuth();
  }, []);

  const login = async (email, password) => {
    console.log('[AuthContext] Starting login for:', email);
    const response = await authAPI.login(email, password);
    console.log('[AuthContext] Login response processed, setting user state');
    setUser(response.user);
    setToken(response.access_token);
    return response;
  };

  const logout = () => {
    console.log('[AuthContext] Logging out...');
    apiLogout();
    setUser(null);
    setToken(null);
  };

  const refreshUser = async () => {
    try {
      const userData = await authAPI.getMe();
      setUser(userData);
      setAuthToken(token, userData);
      return userData;
    } catch (error) {
      console.error('Failed to refresh user:', error);
    }
  };

  const value = {
    user,
    token,
    isAuthenticated: !!user,
    loading,
    login,
    logout,
    refreshUser
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>);

};

export default AuthContext;